import { connectRouter } from "connected-react-router";
import { History } from "history";
import { Reducer, combineReducers } from "redux";
import { FormStateMap, reducer as formReducer } from "redux-form";

import { PageAlertState } from "../../types/appTypes/general";
import { MiniMessageBox, PageAlert } from "../components";
import groupGet, { GroupGetState } from "./appReducers/groups/get";
import pricingLevelsGet, { PricingLevelGetState } from "./appReducers/pricingLevels/get";
import pricingLevelsList, { PricingLevelsListState } from "./appReducers/pricingLevels/list";
import userPermissionsGet, { UserPermissionsGetState } from "./appReducers/userPermissions/get";

interface MiniMessageBoxState {
  show: boolean;
  type: string;
  message: string;
}

export interface RootState {
  form: FormStateMap;
  pageAlert: PageAlertState;
  miniMessageBox: MiniMessageBoxState;
  groupGet: GroupGetState;
  pricingLevelsList: PricingLevelsListState;
  pricingLevelsGet: PricingLevelGetState;
  userPermissionsGet: UserPermissionsGetState;
}

export default (history: History): Reducer =>
  combineReducers({
    form: formReducer,
    router: connectRouter(history),
    miniMessageBox: MiniMessageBox.miniMessageBoxReducer,
    pageAlert: PageAlert.pageAlertReducer,
    groupGet,
    pricingLevelsList,
    pricingLevelsGet,
    userPermissionsGet,
  });
